import { Box, Typography, Grid } from '@mui/material';

import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import { ThemePalette } from 'mui.theme';
import { SVG } from 'components/Asset/SVG';
import { mapVehiclesAssets } from 'utils/helpers/mapAssetImage';
import type { loaderDailyData } from 'types/production.types';
import { convertToTwoDecimalPlaces } from 'components/Charts/Tooltip';
import { convertSeconds } from '../../AllFleet/utils';

import AssetItemChart from 'views/Production/Loader/component/LoaderAssetItemChart';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

const AssetItem = ({
  enableDarkTheme,
  data,
  unitSystem,
  selectedSource,
  customerCode,
}: {
  enableDarkTheme: boolean;
  data: loaderDailyData & {
    make: string | undefined;
    model: string | undefined;
    bumper_id: string | undefined;
    total_load_for_selected_range: number;
  };
  unitSystem: string;
  customerCode: string;
  selectedSource: string;
}) => {
  const { t } = useTranslation();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  return (
    <Box
      sx={{
        height: '350px',
        backgroundColor: enableDarkTheme
          ? palette.paperBackground
          : palette.toolBarBackground,
        border: `1px solid ${palette.cardBorderColor}`,
        marginBottom: '15px',
        padding: '10px',
        borderRadius: '4px',
      }}
      data-attribute="assetItemBox"
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <SVG
          name={mapVehiclesAssets('loader')}
          style={{
            fill: '#E2C171',
            height: '30px',
            width: '60px',
            paddingRight: '10px',
          }}
        />
        <Box>
          <Typography
            sx={{
              color: palette.textSecondary,
              fontSize: '13px',
            }}
          >
            {data?.bumper_id}
          </Typography>
          <Box
            sx={{
              display: 'flex',
            }}
          >
            {/* <PowerSettingsNewIcon
              sx={{
                color: data.loader === 'aa' ? '#00C853' : '#E63946',
                marginRight: '8px',
                fontSize: '12px',
              }}
            /> */}
            <Typography
              sx={{
                fontSize: '10px',
                color: palette.textPrimary,
              }}
            >
              {data?.make} - {data?.model}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: '10px',
        }}
      >
        <Grid
          container
          sx={{
            fontSize: '13px',
            color: palette.textSecondary,
          }}
        >
          <Grid item lg={3} sm={12} xs={12}>
            <Typography
              sx={{
                marginTop: '5px',
                fontSize: '13px',
              }}
            >
              {t('production')}
            </Typography>
            <Typography
              sx={{
                marginTop: '5px',
                fontSize: '11px',
              }}
            >
              {convertToTwoDecimalPlaces(
                data?.total_load_for_selected_range?.toString()
              )}{' '}
              {t('tons_unit')}
            </Typography>
          </Grid>
          <Grid item lg={3} sm={12} xs={12}>
            <Typography
              sx={{
                fontSize: '13px',
              }}
            >
              {t('avg_loads_day')}
            </Typography>

            <Typography
              sx={{
                marginTop: '5px',
                fontSize: '11px',
              }}
            >
              {convertToTwoDecimalPlaces(
                data?.device_loads_per_day?.toString()
              )}{' '}
              {t('tons_unit')}
            </Typography>
          </Grid>

          <Grid item lg={3} sm={12} xs={12}>
            <Typography
              sx={{
                fontSize: '13px',
              }}
            >
              {t('avg_hauler_load_time')}
            </Typography>
            <Typography
              sx={{
                marginTop: '5px',
                fontSize: '11px',
              }}
            >
              {convertToTwoDecimalPlaces(
                convertSeconds(data?.device_hauler_load_time).value.toString()
              )}{' '}
              {convertSeconds(data?.device_hauler_load_time).unit} {t('day')}
            </Typography>
          </Grid>
          <Grid item lg={3} sm={12} xs={12}>
            <Typography
              sx={{
                marginTop: '10px',
                fontSize: '13px',
              }}
            >
              {t('avg_loader_cycle_time')}
            </Typography>
            <Typography
              sx={{
                marginTop: '5px',
                fontSize: '11px',
              }}
            >
              {convertToTwoDecimalPlaces(
                convertSeconds(data?.device_loader_cycle_time).value.toString()
              )}{' '}
              {convertSeconds(data?.device_loader_cycle_time).unit}{' '}
              {t('bucket')}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <AssetItemChart
        enableDarkTheme={enableDarkTheme}
        selectedSource={selectedSource}
        customerCode={customerCode}
        unitSystem={unitSystem}
        height="180px"
        loaderDeviceId={data.loader}
      />
    </Box>
  );
};

export default AssetItem;
